import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@app/environments/environment';
import { IBfFeed } from '@studio/domain';
import { lastValueFrom } from 'rxjs';
import { CreativesetDataService } from '../../creativeset';

@Injectable({ providedIn: 'root' })
export class FeedService {
    private feeds: IBfFeed[];
    timestamp: number;
    constructor(
        private http: HttpClient,
        private creativesetData: CreativesetDataService
    ) {}

    async getFeeds(): Promise<IBfFeed[]> {
        // Cache feeds for 2 minutes
        if (this.feeds && Date.now() - this.timestamp < 1000 * 60 * 2) {
            return this.feeds;
        }
        this.feeds = await lastValueFrom(
            this.http.get<IBfFeed[]>(
                `${environment.origins.sapi}/feeds/${this.creativesetData.brand.id}`
            )
        );
        this.timestamp = Date.now();
        return this.feeds;
    }

    async getNestedFeed(id: string, feeds?: IBfFeed[]): Promise<IBfFeed | undefined> {
        if (!feeds) {
            feeds = feeds = await this.getFeeds();
        }

        for (const feed of feeds) {
            if (feed.id === id) {
                return feed;
            }
            if (feed.children) {
                const feedItem = await this.getNestedFeed(id, feed.children);
                if (feedItem) {
                    return feedItem;
                }
            }
        }
    }
}
